/* eslint-disable eqeqeq */
import { useEffect, useContext } from "react";

import { AuthContext } from "../util/api";
import { useNavigate } from "react-router-dom";


import Navbar from "../header";
import Footer from "../footer";
import DashboardDetails from "./DashboardDetails";

export default function PatientDashboard() {

    const { token, User } = useContext(AuthContext);
    const router = useNavigate();

    useEffect(() => {

        if (User == "" || User == null || token == null) {
            router('/login');
        } else if (User.is_verified == false) {
            router('/client-reg');
        }

    }, []);


    return (

        <>
            <Navbar menuColor="red" />

            <section style={{ marginTop: 100 }}>

                <DashboardDetails />

            </section>

            <Footer />

            {/*   <DashboardDetails></ DashboardDetails>    */}

        </>
    );
}